import dayjs from 'dayjs';

export class DateUtils {
  /** Converts UTC ISO string to local datetime-local format (YYYY-MM-DDTHH:MM) */
  static convertUtcToLocal(utcString) {
    const utcDate = new Date(utcString); // Convert ISO string to Date object
    const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
    const localDateStr = localDate.toISOString().slice(0, 16); // Trim to `YYYY-MM-DDTHH:MM`
    return localDateStr;
  }

  
  /** Converts local datetime-local format (YYYY-MM-DDTHH:MM) back to UTC ISO string */
  static convertLocalToUtc(localString) {
    const localDate = new Date(localString); // Parse local datetime string
    const utcDateStr = localDate.toISOString();
    return utcDateStr;
  }

  static timeZoneName() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  static today(fmt = 'YYYYMMDD') {
    return dayjs().format(fmt);
  }

  static format(yyyymmdd, format = 'MM/DD/YYYY') {
    if (typeof yyyymmdd !== 'number') return '';

    const str = yyyymmdd.toString();
    if (str.length !== 8) return '';

    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    const day = str.slice(6, 8);

    return format
      .replace(/YYYY/, year)
      .replace(/MM/, month)
      .replace(/DD/, day);
  }

  static periodStartDate(period) {
    // first four chars are the year
    const year = period.slice(0, 4);
  
    let month;
    if (period.includes('M')) {
      // month is the two chars after "M"
      month = period.slice(5, 7);
    } else if (period.includes('Q')) {
      // quarter is the single char after "Q"
      const qtr = parseInt(period.slice(5, 6), 10);
      // map Q1→01, Q2→04, Q3→07, Q4→10
      month = String((qtr - 1) * 3 + 1).padStart(2, '0');
    } else {
      throw new Error(`Unsupported period format: "${period}"`);
    }
  
    // always day "01"
    return parseInt(`${year}${month}01`, 10);
  }

  static periodEndDate(period) {
    // year is always the first 4 characters
    const year = period.substring(0, 4);
    let monthStr;
    let dayNum;
  
    if (period.includes('M')) {
      // Monthly: "YYYYMmm"
      monthStr = period.substring(5, 7);
      const monthNum = parseInt(monthStr, 10);
      // JS Date: new Date(year, monthIndex, 0) → last day of that month
      dayNum = new Date(parseInt(year, 10), monthNum, 0).getDate();
    } else if (period.includes('Q')) {
      // Quarterly: "YYYYQq"
      const qtr = parseInt(period.substring(5, 6), 10);
      // Last month of this quarter
      const lastMonthNum = qtr * 3;
      monthStr = String(lastMonthNum).padStart(2, '0');
      // Last day of quarter = last day of lastMonthNum
      dayNum = new Date(parseInt(year, 10), lastMonthNum, 0).getDate();
    } else {
      throw new Error(`Unsupported period format: "${period}"`);
    }
  
    const dayStr = String(dayNum).padStart(2, '0');
    return parseInt(`${year}${monthStr}${dayStr}`, 10);
  }

  static daysBetween(startDate, endDate) {
    const toDate = (d) => {
      const s = d.toString();
      const year  = parseInt(s.slice(0, 4), 10);
      const month = parseInt(s.slice(4, 6), 10) - 1; // zero-based
      const day   = parseInt(s.slice(6, 8), 10);
      // Use UTC to avoid timezone-shift issues
      return new Date(Date.UTC(year, month, day));
    };
  
    const d1 = toDate(startDate);
    const d2 = toDate(endDate);
    const msPerDay = 1000 * 60 * 60 * 24;
    const diffMs = d2.getTime() - d1.getTime();
    return Math.abs(Math.round(diffMs / msPerDay));
  }

  static qtrPeriodFromDate(date) {
    const s = date.toString();
    const year  = parseInt(s.slice(0, 4), 10);
    const month = parseInt(s.slice(4, 6), 10);
    const quarter = Math.floor((month - 1) / 3) + 1;
    return `${year}Q${quarter}`;
  }
}